import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { DateTime } from 'luxon';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { selectAcknowledgementText } from '../../../account-info-header/reducers';
import { ReviewPageActions } from '../../../create-request/actions';
import { Acknowledgement } from '../../../create-request/models/review-page/ReviewPage';
import { selectAcknowledgement, selectReviewPageSubmitClicked } from '../../reducers';
import { Constants, moneyMovementAcknowledgeError, transactionTypes } from '../../utilities/Constants';
import { selectInternalTransfersInfo, selectStagedTransactionForm } from '../../../create-request/reducers';
import { InternalTransfersInfo } from '../../../create-request/models/internal-transfer/InternalTransfersInfo';

@Component({
  standalone: false,
  selector: 'mm-money-movement-acknowledgement-section',
  templateUrl: './money-movement-acknowledgement-section.component.html',
  styleUrls: ['./money-movement-acknowledgement-section.component.scss']
})
export class MoneyMovementAcknowledgementSectionComponent implements OnInit {
  acknowledgementTextResponse: string;
  moneyMovementAcknowledgeText: string;
  moneyMovementAcknowledgeNote: string;
  transactionTypes: string;
  moneyMovementAcknowledgeError: string = Constants.moneyMovementAcknowledgeError;
  isChecked: boolean = false;
  hasError = false;
  submitClicked$: Observable<boolean>;
  destroy$: Subject<boolean> = new Subject<boolean>();
  itsInfo: InternalTransfersInfo;

  constructor(
    private store: Store,
  ) { }

  ngOnInit(): void {
    this.store
    .select(selectStagedTransactionForm)
    .pipe(takeUntil(this.destroy$))
    .subscribe((data) => {
      this.transactionTypes = data.transactionType;
    });
  this.store
    .select(selectInternalTransfersInfo)
    .pipe(takeUntil(this.destroy$))
    .subscribe((itsInfo) => {
      this.itsInfo = itsInfo;
    });

    this.store.select(selectAcknowledgement).pipe(takeUntil(this.destroy$)).subscribe(data => {
      const acknowledgement = data;
      this.hasError = !!Object.keys(acknowledgement.error ?? {}).length;
    });

    this.store.select(selectAcknowledgementText).pipe(takeUntil(this.destroy$)).subscribe(acknowledgementText => {
      this.acknowledgementTextResponse = acknowledgementText
      this.setAcknowledgementText();
    })
    
    this.submitClicked$ = this.store.pipe(
      select(selectReviewPageSubmitClicked)
    );
  }

  setAcknowledgementText() {
    if (
      this.acknowledgementTextResponse === '' &&
      this.transactionTypes == transactionTypes.internalTransfer
    ) {
      this.acknowledgementTextResponse =
        this.itsInfo.acknowledgementArtifactContent;
    }
    const noteIndex = this.acknowledgementTextResponse.indexOf('Note:');
    if (noteIndex !== -1) {
      this.moneyMovementAcknowledgeText = this.acknowledgementTextResponse.substring(0, noteIndex);
      this.moneyMovementAcknowledgeNote = this.acknowledgementTextResponse.substring(noteIndex);
    }
    else {
      this.moneyMovementAcknowledgeText = this.acknowledgementTextResponse;
    }
  }

  checkboxValueChanged() {
    this.isChecked = !this.isChecked;

    let acknowledgement: Acknowledgement= {
      isAcknowledgementReviewed: this.isChecked,
      error: this.isChecked ? undefined : moneyMovementAcknowledgeError,
      acknowledgementConsentTime: DateTime.now().toString()
    }

    if (!this.isChecked)
    {
      acknowledgement.acknowledgementConsentTime = "";
    }
    this.store.dispatch(ReviewPageActions.updateAcknowledgement({acknowledgement}));
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
